import React from "react";
import { usePageHistoryStore } from "../stores/usePageHistoryStore";

// Компонент фільтрів історії сторінки
const HistoryFilters = () => {
  // Отримуємо дані та дії зі стору
  const parentSubjects = usePageHistoryStore((state) => state.parentSubjects);
  const activeSubjectType = usePageHistoryStore(
    (state) => state.filters.activeSubjectType
  );
  const setHistoryFilter = usePageHistoryStore((state) => state.setHistoryFilter);
  const fetchLogs = usePageHistoryStore((state) => state.fetchLogs);
  const subjectTypeMap =
    usePageHistoryStore((state) => state.config?.subjectTypeMap) || {};

  // Обробник кліку на кнопку фільтра
  const handleFilterClick = (subjectType) => {
    // Не робити нічого, якщо фільтр вже активний
    if (subjectType === activeSubjectType) return;

    // Встановлюємо новий фільтр і завантажуємо логи
    setHistoryFilter({ activeSubjectType: subjectType });
    fetchLogs();
  };

  return (
    <div className="history-filters">
      <h4 className="history-filters__title">Фільтри</h4>
      <div className="history-filters__buttons">
        <button
          className={`history-filters__button ${
            activeSubjectType === "all" ? "active" : ""
          }`}
          onClick={() => handleFilterClick("all")}
        >
          Всі
        </button>

        {parentSubjects.map((subject) => (
          <button
            key={subject}
            className={`history-filters__button ${
              activeSubjectType === subject ? "active" : ""
            }`}
            onClick={() => handleFilterClick(subject)}
          >
            {subjectTypeMap[subject] || subject}
          </button>
        ))}
      </div>
    </div>
  );
};

export default HistoryFilters;
